import React from 'react';

const Pagination = ({ totalPages, currentPage, onPageChange }) => {
  const generatePages = () => {
    const pages = [];
    if (totalPages <= 3) {
      // Hiển thị tất cả các trang nếu số lượng trang <= 3
      for (let i = 0; i < totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage > 1) {
        pages.push(0);
        pages.push('...');
      }

      let startPage = Math.max(currentPage - 1, 0);
      let endPage = Math.min(currentPage + 1, totalPages - 1);

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      if (endPage < totalPages - 1) {
        pages.push('...');
        pages.push(totalPages - 1);
      }
    }
    return pages;
  };

  return (
    <div className='pagination-his d-flex justify-content-center align-items-center mt-3 sdsdasdasdasd'>
      {generatePages().map((page, index) => (
        <button
          key={index}
          className={`button second-normal btnMainBorder px-3 py-2 me-2 ${
            page === currentPage ? 'active' : ''
          }`}
          onClick={() => typeof page === 'number' && onPageChange(page)}
          disabled={page === '...'}
        >
          {typeof page === 'number' ? page + 1 : page}
        </button>
      ))}
    </div>
  );
};

export default Pagination;
